import { ADD_COMMENT_REPLIES } from 'root/src/client/logic/comment/actionIds'

export default payload => ({
	type: ADD_COMMENT_REPLIES,
	payload,
})
